export default __webpack_public_path__ + "static/facetedsettings-6ebf6a89430decf2d438aaad3523ac49.png";